export const config: any = {
    pageAddress: "https://hiveslotgames.com",
    gameServerAddress: "https://blackjack-server.hiveslotgames.com",
    gameId: "American_Blackjack",
    maxBet: 120,
    displayCurrency: "HIVE",
    baseCurrency: "mHIVE",
    baseCurrencyDenomination: 1000,
    smallBets: false,
    extremelySmallBets: false,
};



// WEBPACK FOOTER //
// ./src/config.ts